<template>
  <div class="wrapper-book wh100p">
    <section class="section-navs df">
      <div class="nav f-m _themecolor active">
        <el-badge value="" class="dot">
          <div>{{$t('book.bookManage')}}</div>
        </el-badge>
      </div>
    </section>

    <section class="section-search _bordertop df-c-sb">
      <div class="df-c-fs box">
        <el-badge :value="x.num||''" class="dot" v-for="(x,i) in dayBtns" :key="i">
          <div class="btn" :class="i===dayBtnAc?'themebtn-xs':'whitebtn-xs'" @click="dayClick(i)">{{$t('book.'+x.key)}}</div>
        </el-badge>
      </div>
    </section>

    <section class="section-table">
      <div class="table-box" ref="tablebox">
        <el-table
          ref="tableRef"
          :data="tableDatas"
          :max-height="tableMaxHeight"
          @expand-change="expandChange"
          @cell-click="cellClick"
          @row-click="rowClick">
          <!-- :row-class-name="tableRowClassName" -->
          <!-- stripe border highlight-current-row -->
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="remark">{{scope.row.remark}}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('book.contract')" min-width="100" align="center">
            <template slot-scope="scope">
              <div class="df-c-fs">
                <div class="_themecolor f-xl sls name">{{scope.row.contactName}}</div>
              </div>
              <div class="df-c-fs">
                <img src="../../../assets/icons/person.png" class="avator">
                <div class="_goldbackground _cf f-xxs num" v-if="scope.row.bookType===2">{{$t('book.bookWhole')}}</div>
                <div class="_goldbackground _cf f-xxs num" v-else>{{scope.row.number}}{{$t('book.seat')}}{{lang==='en'&&scope.row.number>1?'s':''}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('book.bookTime')" min-width="80" align="center">
            <template slot-scope="scope">
              <div class="_goldcolor f-m time">{{scope.row.time1}}</div>
              <div class="_c9 f-xxs">{{scope.row.date1}}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('book.phoneNumber')" min-width="100" align="center">
            <template slot-scope="scope">
              <div class="_themecolor f-s tel">{{scope.row.contactPhone}}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('book.createTime')" min-width="82" align="center">
            <template slot-scope="scope">
              <div>
                <div class="_c9 f-xxs">{{scope.row.time2}}</div>
                <div class="_c9 f-xxs">{{scope.row.date2}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('book.remark')" min-width="100" align="center">
            <template slot-scope="scope">
              <div class="_c9 f-xxs slm2">{{scope.row.remark}}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.action')" :min-width="lang=='en'?'174':'160'" align="center">
            <template slot-scope="scope">
              <div class="df-c-ct" @click.stop.prevent="()=>{}">
                <div class="text _redcolor" v-if="scope.row.status===2">{{$t('book.refused')}}</div>
                <div class="text _greencolor" v-if="scope.row.status===3">{{$t('book.arrivaled')}}</div>
                <div class="text _redcolor" v-if="scope.row.status===4">{{$t('book.canceled')}}</div>
                <div class="text _redcolor" v-if="scope.row.status===5">{{$t('book.unarrival')}}</div>
                <div class="btn themebtn-xs" v-if="scope.row.status===1" @click.stop.prevent="arrivalClick(scope.row)">{{$t('book.arrival')}}</div>
                <div class="btn whitebtn-xs" v-if="scope.row.status===1" @click.stop.prevent="unarrivalClick(scope.row)">{{$t('book.unarrival')}}</div>
                <div class="btn whitebtn-xs" v-if="scope.row.status===1" @click.stop.prevent="cancelClick(scope.row,4)">{{$t('book.cancel')}}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagenation :pageData="pageData" @pageChange="pageChange" />
    </section>

    <DialogRefuse ref="DialogRefuse" />

  </div>
</template>

<script>
import DialogRefuse from './components/DialogRefuse'
import mixin_table_simple from '@/mixins/mixin_table_simple'
export default {
  name: 'book',
  mixins: [mixin_table_simple],
  inject: ['waitingBookSearch'],
  components: { DialogRefuse },
  data() {
    return {
      dayBtns: [
        {num:'',key:'today'},
        {num:'',key:'tomorrow'},
        {num:'',key:'all'}
      ],
      dayBtnAc: 2,

      tableDatas: [], // 列表数据
      rowClicked: null, // 点击的行
      expandRowIds: [], // 已经展开的行id

      timer_list: null, // 定时器

      otherHeight: 340,
    }
  },
  methods: {
    // #region 页面交互（按钮点击）
    // 快速筛选
    dayClick(index) {
      this.pageData.currentPage = 1
      this.dayBtnAc = index
      this.initData()
    },
    // 到店确认
    arrivalClick(row) {
      this.rowClicked = row
      this.statusHandler(3)
    },
    // 未到店确认
    unarrivalClick(row) {
      this.dangerousBtnClick(row, 5)
    },
    // 取消预定
    cancelClick(row) {
      this.dangerousBtnClick(row, 4)
    },
    dangerousBtnClick(row, status) {
      this.$confirm(this.$t('common.hanldeIsDangerous'), this.$t('common.tips'), {
        confirmButtonText: this.$t('common.yes'),
        cancelButtonText: this.$t('common.no'),
        type: 'warning',
        distinguishCancelAndClose: true,
      }).then(async () => {
        this.rowClicked = row
        this.el_loading_x_save(true)
        this.$api.book_cancel({
          shopId: this.currentShopId,
          id: this.rowClicked.id,
          status,
        }).then(resp => {
          this.$message.success(this.$t('common.handleSuccess'))
          this.rowClicked.status = status

          this.el_loading_x_save(false)

          this.waitingBookSearch()
        }).catch(res => {
          this.el_loading_x_save(false)
        })
      }).catch(async (e) => {
      })
    },
    cellClick(row, column, cell, event) {
      this.isCanRowClick = column.id !== 'el-table_1_column_7'
    },
    // 点击扩展行
    rowClick(row, column, event) {
      // console.log(11, row, column, event)
      let expanded = this.isCanRowClick && !this.expandRowIds.includes(row.id)
      this.$refs.tableRef.toggleRowExpansion(row, expanded)
    },
    expandChange(row, rows) {
      // console.log(22, row, rows)
      this.expandRowIds = rows.map(x1 => x1.id)
    },
    // #endregion

    // #region 发送请求
    statusHandler(status) {
      this.el_loading_x_save(true)
      let rData = {
        id: this.rowClicked.id,
        status,
      }
      return this.setData('book', rData).then(resp => {
        this.$message.success(this.$t('common.handleSuccess'))
        this.rowClicked.status = rData.status

        this.el_loading_x_save(false)

        this.waitingBookSearch()
      }).catch(res => {
        this.el_loading_x_save(false)
      })
    },
    // #endregion

    // #region 数据获取
    async initData() {
      this.getTableData(true)

      await this.waitingBookSearch(true)
      this.dayBtns[0].num = this.menuCount_x.waitingBookCount

      this.timer_list && clearInterval(this.timer_list)
      this.timer_list = setInterval(() => {
        // console.log(`%c定时器执行了:`, 'color: #00f;', )
        this.initData()
      }, 30000)
    },
    async getTableData(autoOnlyBendRead = false) {
      this.el_loading_x_save(true)

      let rD = {
        shopId: this.currentShopId,
        sortField: ['eatStartTime'],
        sortType: 'DESC',
        pageSize: this.pageData.pageSize,
        pageNumber: this.pageData.currentPage,
        autoOnlyBendRead,
      }

      // #region 日期
      console.log(this.dayBtnAc)
      if ([0, 1].includes(this.dayBtnAc)) {
        const today0 = new Date(new Date().toLocaleDateString()).getTime()
        const today24 = today0 + 24 * 60 * 60 * 1000 - 1
        const tomorrow0 = today24 + 1
        const tomorrow24 = tomorrow0 + 24 * 60 * 60 * 1000 - 1
        if (this.dayBtnAc === 0) {
          rD.startTime = today0
          rD.endTime = today24
          rD.searchToday = true
        } else if (this.dayBtnAc === 1) {
          rD.startTime = tomorrow0
          rD.endTime = tomorrow24
        }
      }
      // #endregion

      const _R = await this.getData('book', rD, { replace: true })
      // console.log(`%c查询的预定列表:`, 'color: #f00;', _R)
      this.tableDatas = _R.map(x1 => {
        // x1.date1 = x1.eatStartDate && x1.eatStartDate.substr(0, 10)
        // x1.time1 = x1.eatStartDate && x1.eatStartDate.substr(11, 19)
        x1.date1 = x1.bookDate && x1.bookDate.substr(0, 10)
        x1.time1 = x1.bookDate && x1.bookDate.substr(11, 19)
        x1.date2 = x1.createDate && x1.createDate.substr(0, 10)
        x1.time2 = x1.createDate && x1.createDate.substr(11, 19)
        return x1
      })

      // this.el_loading_x_save(false)
    },
    // #endregion
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.timer_list && clearInterval(this.timer_list)
    next()
  },
}
</script>

<style lang='scss' scoped>
@import '@/assets/css/util_table.scss';
// .wrapper-book{padding: 20px 0 0 20px;box-sizing: border-box;}
.section-title{height: 80px;line-height: 80px;background: #fff;padding-left: 20px;margin-bottom: 20px;font-weight: bold;}
.section-navs{
  height: 80px;line-height: 80px;background: #fff;padding: 0 10px;
  overflow: scroll hidden;z-index: 3;position: relative;
  .nav{padding: 0 10px;width: auto;white-space: nowrap;}
  .nav.active{font-weight: bold;}
  .dot /deep/.el-badge__content{background: #EA4646;border: 0;bottom: 0;margin: auto;right: 10px;}
  .draw-switch{position: absolute;top: 0;bottom: 0;right: 40px;margin: auto;width:40px;height:40px;}
}

.section-search{
  height: 80px;background: #fff;z-index: 3;position: relative;padding: 0 20px;box-sizing: border-box;
  .box{
    position: relative;
    .btn{margin: 0 10px;}
    .dot /deep/.el-badge__content{background: #EA4646;border: 0;bottom: 10;margin: auto;right: 20px;}
  }
}

.section-table{
  height: calc(100% - 180px);margin-top: 20px;
  .table-box{height: calc(100% - 100px);overflow: hidden scroll;}

  .name{padding: 8px 0;}
  .avator{width: 19px;height: 16px;}
  .num{min-width: 40px;height: 20px;line-height: 20px;text-align: center;border-radius: 10px;margin-left: 8px;padding: 0 8px;}
  .time{font-weight: bold;}
  .btn{margin: 0 4px;}
  .text{min-width: 80px;margin: 0 4px;}
  .remark{line-height: 24px;}
}

// #region 扩展行
.table-expand {
  font-size: 0;
}
.table-expand label {
  width: 90px;
  color: #99a9bf;
}
.table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
/deep/.el-table__expand-column{
  padding: 0;
  .cell{
  padding: 0;
    height: 100%;
  }
}
// #endregion
</style>